import React from 'react';
import { Button } from '@fluentui/react-components';
import './ErrorBoundary.css';

// App-level guard so a render error in one page can't white-screen the whole app.
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('Unhandled UI error:', error, info);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-container">
                    <h1 className="error-boundary-title">Something went wrong</h1>
                    <p className="error-boundary-description">
                        This page hit an unexpected error and couldn't render. You can try again or
                        head back home.
                    </p>
                    {this.state.error?.message && (
                        <pre className="error-boundary-detail">{this.state.error.message}</pre>
                    )}
                    <div className="error-boundary-actions">
                        <Button appearance="primary" onClick={this.handleReset}>Try again</Button>
                        <Button appearance="secondary" onClick={() => { window.location.href = '/'; }}>
                            Back to Home
                        </Button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
